export const mockExam = {
  id: 'sample-exam',
  title: 'Пробна матура по математика за 7. клас - 28.03.2026',
  description: 'Модул 1 - Математика',
  durationMinutes: 90,
  introTitle: 'Преди да започнете примерния изпит',
  introDescription:
    'Този изпит е по формата на НВО за 7. клас. Разполагате с 90 минути, за да решите всички въпроси от първи модул.',
  guidelines: [
    'Уверете се, че имате стабилна интернет връзка преди да започнете.',
    'След натискане на бутона „Започни изпита“ таймерът започва да отброява времето.',
    'Ако не сте сигурни за някоя задача, пропуснете я и продължете с следващата.',
    'Не затваряйте и не презареждайте страницата по време на изпита.',
    'Когато времето изтече, изпитът ще бъде предаден автоматично и отговорите няма да могат да се редактират.',
    'Копирането и разпространение на задачите и отговорите е забранено.',
    'Не се допускат помощни материали, калкулатори и други електронни устройства.',
    'Не бързайте да решавате задачите, четете внимателно условието и предложените отговори.',
  ],
  questions: [
    {
      id: 'q1',
      type: 'single',
      text: 'В правоъгълния триъгълник $ABC$ на чертежа катетите са $|AB| = 3$ cm и $|BC| = 4$ cm. Колко е дължината на хипотенузата $|AC|$?',
      imageSrc: '/Triangle90_bg.webp',
      points: 5,
      options: [
        { id: 'q1-o1', label: '3 cm' },
        { id: 'q1-o2', label: '4 cm' },
        { id: 'q1-o3', label: '5 cm' },
        { id: 'q1-o4', label: '7 cm' },
      ],
      correctOptionId: 'q1-o3',
    },
    {
      id: 'q2',
      type: 'single',
      text: 'Дадена е функцията $f(x) = x^2 - 4x + 3$. Кое от числата е корен на уравнението $f(x) = 0$?',
      points: 5,
      options: [
        { id: 'q2-o1', label: 'x = 1' },
        { id: 'q2-o2', label: 'x = 2' },
        { id: 'q2-o3', label: 'x = 3' },
        { id: 'q2-o4', label: 'x = 4' },
      ],
      correctOptionId: 'q2-o1',
    },
    {
      id: 'q3',
      type: 'single',
      text: 'Стойността на израза $\\displaystyle \\int_0^1 2x \\, dx$ е равна на:',
      points: 10,
      options: [
        { id: 'q3-o1', label: '$0$' },
        { id: 'q3-o2', label: '$1$' },
        { id: 'q3-o3', label: '$2$' },
        { id: 'q3-o4', label: '$\\frac{1}{2}$' },
      ],
      correctOptionId: 'q3-o2',
    },
    {
      id: 'q4',
      type: 'single',
      text: 'В равностранен триъгълник страната е $6$ cm. Колко е дължината на височината към една от страните?',
      points: 5,
      options: [
        { id: 'q4-o1', label: '$3$ cm' },
        { id: 'q4-o2', label: '$3\\sqrt{3}$ cm' },
        { id: 'q4-o3', label: '$6$ cm' },
        { id: 'q4-o4', label: '$6\\sqrt{3}$ cm' },
      ],
      correctOptionId: 'q4-o2',
    },
    {
      id: 'q5',
      type: 'file',
      text: 'Качи снимка или PDF с подробно ръчно решение на една от задачите по-горе.',
      points: 5,
    },
    {
      id: 'q6',
      type: 'multi',
      text: 'Реши уравненията:',
      points: 6,
      subquestions: [
        { id: 'q6-s1', text: '$2x = 8$', correctAnswer: '4' },
        { id: 'q6-s2', text: '$x + 5 = 12$', correctAnswer: '7' },
        { id: 'q6-s3', text: '$3x - 6 = 9$', correctAnswer: '5' },
      ],
    },
  ],
};

